module.exports = __webpack_public_path__ + "static/banner4-46fd3090c3607c6c3789aba06a96a330.png";